import React from "react";
import "./BlueBtn.css";

const BlueBtn = ({
  btnText,
  onClick,
  type = "button",
  className = "",
  children,
}) => {
  return (
    <button
      type={type}
      className={`BlueBtn ${className}`}
      onClick={onClick}
    >
      {children || btnText}
    </button>
  );
};

export default BlueBtn;
